import Vue from "vue";
import Vuex from "vuex";
import config from "./store/global-config";
import user from "./store/user";
import userConfig from "./store/user-config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    config,
    user,
    userConfig
  }
});
